(() => {
  const init = (root = document) => {
    root.querySelectorAll('.wa-videos, .wa-benefits').forEach(section => {
      if (section.dataset.affiliateReady) return;
      section.dataset.affiliateReady = 'true';
      const track = section.querySelector('.wa-videos__track, .wa-benefits__track');
      const dots = [...section.querySelectorAll('.wa-dots span')];
      const arrows = [...section.querySelectorAll('[data-direction]')];
      const update = () => {
        const first = track.firstElementChild;
        if (!first) return;
        const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
        const index = Math.round(track.scrollLeft / step);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        arrows.forEach(button => {
          button.disabled = Number(button.dataset.direction) < 0
            ? track.scrollLeft <= 2
            : track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        });
      };
      arrows.forEach(button => button.addEventListener('click', () => {
        track.scrollBy({left: Number(button.dataset.direction) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(track);
      section.querySelectorAll('[data-play-video]').forEach(button => {
        button.addEventListener('click', () => {
          const card = button.closest('.wa-video');
          const video = card.querySelector('template').content.firstElementChild.cloneNode(true);
          section.querySelectorAll('video').forEach(other => other.pause());
          card.append(video);
          card.querySelector('.wa-video__poster').hidden = true;
          button.remove();
          video.focus();
          video.play().catch(() => {});
        }, {once: true});
      });
      update();
    });
  };
  if (!window.waAffiliateInitialized) {
    window.waAffiliateInitialized = true;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:block:select', event => {
      const card = event.target.closest('.wa-video, .wa-benefit');
      if (card) card.parentElement.scrollLeft = card.offsetLeft - card.parentElement.firstElementChild.offsetLeft;
    });
  }
})();
